<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-card class="mt-2 pb-8 mb-5" flat>
					<v-card-title>
						<v-subheader>
							<span class="title font-weight-normal">Filtrar contratos</span>
						</v-subheader>
						<v-spacer></v-spacer>
						<v-btn class="white--text mr-2" depressed color="#34bfa3" @click="$router.push('/contracts/new')">+
							Novo</v-btn>
						<v-btn class="white--text" depressed color="info" @click="filter()">Buscar</v-btn>
						<search-filter-default v-model="filters" />
					</v-card-title>
				</v-card>
				<v-card flat>
					<v-data-table :headers="headers" :items="items" :items-per-page="pagination.itemsPerPage"
						v-bind:loading="loading" loading-text="Aguarde...carregando" :hide-default-footer="true">
						<template v-slot:body="{ items }">
							<tr v-for="item in items" :key="item.GERCON">
								<td>
									<v-btn @click="edit(item.GERCON, !canEdit(item))" icon>
										<v-icon v-if="canEdit(item)" style="color: orange">
											mdi-pencil
										</v-icon>
										<v-icon v-else>
											mdi-eye
										</v-icon>
									</v-btn>
								</td>

								<td align="center">{{ item.GERCON }}</td>
								<td>{{ item.group ? item.group.DESGRP : "" }}</td>
								<td>
									{{ item.corporate_area ? item.corporate_area.DESAREA : "" }}
								</td>
								<td>{{ item.company ? item.company.DESABR : "" }}</td>
								<td>{{ item.unit ? item.unit.DESABR : "" }}</td>
								<td>{{ item.area ? item.area.DESARE : "" }}</td>
								<td>{{ item.RAZAO_PARTE }}</td>
								<td align="center">{{ contractTypeEnum[item.TIPCON] }}</td>
								<td>{{ item.TITCON }}</td>
								<td>
									<v-btn @click="remove(item.GERCON)" :disabled="user.CODUSU !== item.USUCAD" icon>
										<v-icon style="color: red">mdi-delete</v-icon>
									</v-btn>
								</td>
								<!-- <td v-else>
									<v-btn @click="edit(item.GERCON)" icon>
										<v-icon>mdi-eye</v-icon>
									</v-btn>
								</td> -->
							</tr>
						</template>
					</v-data-table>

					<pagination v-model="pagination" @change="loadData" :loading="loading" />
				</v-card>
			</v-col>
		</v-row>
		<template>
			<Dialog ref="confirm" />
		</template>
	</v-container>
</template>

<script>
import SearchFilterDefault from "@/components/contract/SearchFilterDefault.vue";
import pagination from "@/components/pagination/Pagination.vue";
import PaginationMixin from "@/components/pagination/PaginationMixin";
import ContractsService from "../../app/Services/ContractsService";
import Dialog from "../misc/Dialog";
import { ContractTypeEnum } from "./enums/ContractTypeEnum";

export default {
	name: "ContractsList",
	components: { Dialog, SearchFilterDefault, pagination },
	mixins: [PaginationMixin],
	mounted() {
		const userData = JSON.parse(localStorage.getItem("user"));

		if (userData && "user" in userData) {
			this.user = userData["user"];
		}
		this.loadData();
	},
	data: () => ({
		contractTypeEnum: ContractTypeEnum,
		loading: false,
		filters: {},
		user: {},
		headers: [
			{
				text: "",
				align: "left",
				sortable: false,
				value: "status",
				width: "3%",
			},
			{
				text: "Código",
				align: "center",
				sortable: true,
				value: "GERCON",
				width: "10%",
			},
			{
				text: "Grupo",
				align: "left",
				sortable: true,
				value: "group.DESGRP",
				width: "10%",
			},
			{
				text: "Área Corporativa",
				align: "left",
				sortable: true,
				value: "corporateArea.DESABR",
				width: "10%",
			},
			{
				text: "Empresa",
				align: "left",
				sortable: true,
				value: "company.DESABR",
				width: "10%",
			},
			{
				text: "Unidade",
				align: "left",
				sortable: true,
				value: "unit.DESABR",
				width: "10%",
			},
			{
				text: "Area",
				align: "left",
				sortable: true,
				value: "area.DESARE",
				width: "10%",
			},
			{
				text: "Razão Social",
				align: "left",
				sortable: true,
				value: "item.RAZAO_PARTE",
				width: "10%",
			},
			{
				text: "Tipo",
				align: "center",
				sortable: true,
				value: "TIPCON",
				width: "20%",
			},
			{
				text: "Título",
				align: "left",
				sortable: true,
				value: "TITCON",
				width: "40%",
			},
			{
				text: "",
				align: "left",
				sortable: false,
				value: "status",
				width: "3%",
			},
		],
		items: [],
	}),
	methods: {
		canEdit(item) {
			if (this.isUserEvaluator && [2, 3].includes(item.SITUACAO)) {
				return true;
			}

			if (this.user.CODUSU === item.USUCAD && [1, 4, 5].includes(item.SITUACAO)) {
				return true;
			}

			return false;
		},
		toast(type, message, icon = "mdi-check") {
			this.$toasted.show(message, {
				type: type,
				icon: icon,
			});
		},
		async loadData() {
			try {
				this.loading = true;

				const filter = this.filters;

				const query = {
					params: {
						filter,
						user: this.user.CODUSU,
						...this.pagination,
					},
				};

				const response = await ContractsService.build().index({
					query,
				});

				this.isUserEvaluator = response.isUserEvaluator;
				this.items = response.contracts.data;
				this.loading = false;

				this.paginate(response.contracts);
			} catch (e) {
				// eslint-disable-next-line no-console
				console.log(e);
				this.defaultCatchError(e);
			} finally {
				this.loading = false;
			}
		},
		filter() {
			this.searching = true;
			this.items = [];
			this.pagination.page = 1;

			this.loadData();
		},
		edit(id, view) {
			this.$router.push({
				name: "ContractsEdit",
				params: {
					id: id,
					view: view,
				},
			});
		},
		async remove(id) {
			await this.$refs.confirm
				.open("Atenção", `Deseja excluir o contrato ${id}?`)
				.then(() => {
					this.$root.$Loading.show("Removendo o contrato...");

					ContractsService.build()
						.destroy({
							id: id,
						})
						.then(() => {
							this.toast("success", "Contrato removido com sucesso!");

							this.$root.$Loading.hide();

							this.loadData();
						});
				});
		},
	},
};
</script>
